const LocationSection = ({
  register,
  locations,
  errors,
}) => {
  const handlePincodeKeyDown = (e) => {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
    if (allowedKeys.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const sanitizePincodeInput = (e) => {
    e.target.value = String(e.target.value || '').replace(/\D/g, '').slice(0, 6);
  };

  const deliveryTypeOptions = [
    { value: 'local', label: 'Local' },
    { value: 'nonlocal', label: 'Nonlocal' },
    { value: 'local_45_kms', label: 'Local>45KMS' },
  ];

  const renderAddressBlock = (prefix, label) => (
    <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">{label} Address</h4>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">Code</label>
          <input
            {...register(`${prefix}.short_code`)}
            type="text"
            className="border rounded p-2 text-sm w-full bg-white uppercase"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">Delivery Type</label>
          <select
            {...register(`${prefix}.delivery_type`)}
            className="border rounded p-2 text-sm w-full bg-white uppercase"
          >
            <option value="">Select Delivery Type</option>
            {deliveryTypeOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-3">
        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">Address Line 1</label>
          <input
            {...register(`${prefix}.address_line1`)}
            type="text"
            className="border rounded p-2 text-sm w-full bg-white uppercase"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">Address Line 2</label>
          <input
            {...register(`${prefix}.address_line2`)}
            type="text"
            className="border rounded p-2 text-sm w-full bg-white uppercase"
          />
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4 mt-3">
        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">City</label>
          <input
            {...register(`${prefix}.city`)}
            type="text"
            className="border rounded p-2 text-sm w-full bg-white uppercase"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">State</label>
          <input
            {...register(`${prefix}.state`)}
            type="text"
            className="border rounded p-2 text-sm w-full bg-white uppercase"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">Pincode</label>
          <input
            {...register(`${prefix}.pincode`)}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={6}
            onKeyDown={handlePincodeKeyDown}
            onInput={sanitizePincodeInput}
            onPaste={sanitizePincodeInput}
            className="border rounded p-2 text-sm w-full bg-white"
          />
        </div>
      </div>
    </div>
  );

  return (
    <section>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">Origin</label>
          <select
            {...register('from')}
            className="border rounded p-2 text-sm w-full uppercase"
          >
            <option value={'0'}>Others</option>
            {locations.map((l) => (
              <option key={l.tid} value={l.tid}>{l.full_address}</option>
            ))}
          </select>
          {errors.from_location && (
            <p className="text-red-500 text-sm mt-1">{errors.from_location[0]}</p>
          )}
        </div>

        <div className="flex flex-col">
          <label className="text-xs text-gray-600 mb-1">Destination</label>
          <select
            {...register('to')}
            className="border rounded p-2 text-sm w-full uppercase"
          >
            <option value={'0'}>Others</option>
            {locations.map((l) => (
              <option key={l.tid} value={l.tid}>{l.full_address}</option>
            ))}
          </select>
          {errors.to_location && (
            <p className="text-red-500 text-sm mt-1">{errors.to_location[0]}</p>
          )}
        </div>
      </div>

      <h3 className="text-sm font-semibold mb-2 mt-4">Others Location</h3>
      <div className="grid md:grid-cols-2 gap-4">
        {renderAddressBlock('from_location', 'Origin')}
        {renderAddressBlock('to_location', 'Destination')}
      </div>
    </section>
  );
};

export default LocationSection;
